import React, { useEffect, useState } from "react";
import {
    useTheme,
    TextField,
    IconButton,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    Grid,
    Paper,
    Box,
    FormControl,
    NativeSelect,
    InputLabel,
    Card,
    CardContent,
    Typography,
    Select,
    MenuItem,
    Tooltip,
    Tab,
    Tabs,
    InputAdornment,
    Skeleton
  } from "@mui/material";
import { tokens } from "../theme";
import axios from "axios";
import Cookies from "js-cookie";
import Header from "../Components/Header";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import useMediaQuery from "@mui/material/useMediaQuery";
import { FaEdit, FaTrash, FaInfoCircle } from "react-icons/fa";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import SearchIcon from '@mui/icons-material/Search';
import { ToastContainer, toast } from "react-toastify";
import baseURL from "../config";
import CryptoJS from "crypto-js";
import RecordsTable from "../Components/RecordsTable";

const Transactions = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [filteredtransactionData, setFilteredTransactionData] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const isNonMobile = useMediaQuery("(min-width:620px)");
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [username, setUsername] = useState("");
  const [posName, setPosName] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const [transactionData, setTransactionData] = useState({
    Id: 0,
    userId: "",
    store: "",
    CreateDate: null,
    transactionAmount: "",
    bonusPoints: "",
    PosBrandId: 0,
   TransactionLines: []
});

const getDecryptedToken = () => {
  const encryptedToken = Cookies.get("token");
  if (!encryptedToken) return null;

  const secretKey = '19092002'; 
  const bytes = CryptoJS.AES.decrypt(encryptedToken, secretKey);
  const decryptedToken = bytes.toString(CryptoJS.enc.Utf8);

  return decryptedToken || null;
};


const token = getDecryptedToken();

//api calls
const fetchTransactions = async () => {
    try {
      const response = await axios.get(baseURL + "/api/Transaction/GetTransactions", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
  
      if (response.status === 200) {
        const transactions = response.data.message;
        
        const transactionsWithUsernames = await Promise.all(
          transactions.map(async (transaction) => {
            try {
              const userResponse = await axios.get(`${baseURL}/api/User/GetUser`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { id: transaction.userId },
              });
              
              if (userResponse.status === 200) {
               setIsLoading(false);
                return {
                  ...transaction,
                  username: userResponse.data.user.name || "Unknown User",
                };
              }
            } catch (error) {
              console.error(`Error fetching username for userId ${transaction.userId}:`, error);
              return {
                ...transaction,
                username: "Error Fetching Username",
              };
            }
          })
        );
  
        setTransactionData(transactionsWithUsernames);
        setFilteredTransactionData(transactionsWithUsernames);
      }
    } catch (error) {
      setTransactionData([]);
      setFilteredTransactionData([]);
      setIsLoading(false);
      toast.error("Te dhenat nuk u gjeten!");
    }
  };
  


useEffect(() => {
      fetchTransactions();
}, [token]);


//this method fetches a transaction based on userId
const fetchTransactionById = async (ID) => {
    try {
      const response = await axios.get(
        baseURL+"/api/Transaction/GetTransactionById", 
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            id: ID, 
          },
        }
      );
  
      if (response.status == 200) {
        const transaction = response.data.message;
        setTransactionData(transaction);
      } else {
        toast.error("Failed to fetch transactions: Success flag is false");
      }
    } catch (err) {
      toast.error("Error fetching transactions:", err);
    }
  };

  const fetchUsername = async (userId) => {
    try{
        const response = await axios.get(`${baseURL}/api/User/GetUser`, {
            headers: { Authorization: `Bearer ${token}` },
            params: { id: userId },
          });

          if(response.status === 200){
            const user = response.data.user;
            const username = user.name;
            setUsername(username);
          }else {
            toast.err("Failed to fetch user details");
          }
    }catch (error) {
        toast.error("Error fetching user!");
    }
  };

  const fetchPosName = async (posId) => {
    try {
      const response = await axios.get(
        baseURL+"/api/PointOfSale/GetPOSById", 
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            id: posId, 
          },
        }
      );
  
      if (response.status == 200) {
        const pos = response.data;
        const posname = pos.name;
        setPosName(posname);
      } else {
        toast.error("Failed to fetch pos: Success flag is false");
      }
    } catch (err) {
      toast.error("Error fetching pos:", err);
    }
  };

  const handleSave = async () => {
    try {
      const response = await axios.post(
        baseURL+"/api/PointOfSale/EditPos", 
        transactionData, 
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      if (response.status == 200) {
  
        
        
        const updatedTransaction = fetchTransactions(); 
        setFilteredTransactionData(updatedTransaction);
        setDialogOpen(false);
  
       
        toast.success("Pos u perditesua me sukses!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error("Failed to update pos: Success flag is false");
      }
    } catch (error) {
      console.error("Error updating pos:", error);
      alert("Failed to update user.");
    }
  };
  
  

  const handleEdit = (event) => {
    setTransactionData({
      ...transactionData,
      [event.target.name]: event.target.value,
    });
  
  };

  

  const handleInfo = (id, userId, posId) => {
    fetchTransactionById(id);
    fetchUsername(userId);
    fetchPosName(posId);
    setSelectedTransaction(id);
    setDialogOpen(true);
    
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const onDeleteClick = (id) => {

  }

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };
  
  const filteredData = filteredtransactionData.filter((transaction) => {
    const searchQueryLower = searchQuery.toLowerCase();
    return (
      (transaction.transactionAmount && transaction.transactionAmount.toString().includes(searchQueryLower)) ||
      (transaction.userId && transaction.userId.toString().includes(searchQueryLower)) ||
      (transaction.username && transaction.username.toLowerCase().includes(searchQueryLower)) ||
      (transaction.id && transaction.id.toString().includes(searchQueryLower)) ||
      (transaction.createDate && transaction.createDate.toString().includes(searchQueryLower)) ||
      (transaction.posid && transaction.posid.toString().includes(searchQueryLower))
    );
  });
  

  const desktopColumns = [
    {
      field: "id",
      headerName: "ID",
      headerClassName: 'super-app-theme--header',
      flex: 0.4,
      renderCell: (params) => <span className="table-muted">#{params.value}</span>,
    },
    {
      field: "username",
      headerName: "User",
      headerClassName: 'super-app-theme--header',
      flex: 1,
      renderCell: (params) => <span className="table-strong">{params.value || "Unknown"}</span>,
    },
    {
      field: "userId",
      headerName: "User ID",
      headerClassName: 'super-app-theme--header',
      flex: 0.7,
      renderCell: (params) => <span className="table-muted">#{params.value}</span>,
    },
    {
      field: "posid",
      headerName: "POS",
      headerClassName: 'super-app-theme--header',
      flex: 0.7,
      renderCell: (params) => <span className="table-pill">#{params.value}</span>,
    },
    {
      field: "transactionAmount",
      headerName: "Amount",
      headerClassName: 'super-app-theme--header',
      flex: 0.9,
      renderCell: (params) => <span className="table-strong">{Number(params.value || 0).toFixed(2)} €</span>,
    },
    {
      field: "bonusPoints",
      headerName: "Points",
      headerClassName: 'super-app-theme--header',
      flex: 0.8,
      renderCell: (params) => <span className="table-pill success">{params.value || 0} pts</span>,
    },
    {
      field: "createDate",
      headerName: "Created",
      headerClassName: 'super-app-theme--header',
      flex: 1.1,
      renderCell: (params) => (
        <span className="table-muted">
          {params.value ? new Date(params.value).toLocaleDateString() : "N/A"}
        </span>
      ),
    },
  
        {
            field: "Actions",
            headerName: "",
            flex: 0.35,
            sortable: false,
            filterable: false,
            headerClassName: 'super-app-theme--header',
      
            renderCell: (params) => {
              return (
                <>
                  <IconButton
                    onClick={() => handleInfo(params.row.id, params.row.userId, params.row.posid)}
                    className="table-action-button"
                    aria-label="View transaction"
                  >
                    <DriveFileRenameOutlineIcon />
                  </IconButton>    
                </>
              );
            },
          },
        ];

  const mobileColumns = [
    {
      field: "username",
      headerName: "User",
      headerClassName: 'super-app-theme--header',
      flex: 1,
      renderCell: (params) => <span className="table-strong">{params.value || "Unknown"}</span>,
    },
    {
      field: "transactionAmount",
      headerName: "Amount",
      headerClassName: 'super-app-theme--header',
      flex: 1,
      renderCell: (params) => <span className="table-strong">{Number(params.value || 0).toFixed(2)} €</span>,
    },
    {
      field: "Actions",
      headerName: "",
      flex: 0.5,
      sortable: false,
      filterable: false,
      headerClassName: 'super-app-theme--header',

      renderCell: (params) => {
        return (
          <>
            <IconButton
              onClick={() => handleInfo(params.row.id, params.row.userId, params.row.posid)}
              className="table-action-button"
              aria-label="View transaction"
            >
              <DriveFileRenameOutlineIcon />
            </IconButton>    
          </>
        );
      },
    },
  ]

  const columns = isNonMobile ? desktopColumns : mobileColumns;

  return (
    <Box m="10px">
      <Header title="Transaksionet" subtitle="Shiko detajet per Transaksione" />
      <ToastContainer />
      <Box mb={2} display="flex" justifyContent="flex-start">
        <TextField
          label="Search"
          variant="outlined"
          onChange={handleSearch}
          sx={{ backgroundColor: colors.primary[600], width: isNonMobile ? "30%" : "50%" }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />

      </Box>

      <Box
        m="10px 0 0 0"
        sx={{
          "& .MuiDataGrid-root": { border: "none" },
          "& .MuiDataGrid-cell": { borderBottom: "none" },
          "& .name-column--cell": { color: "#3b0a45" },
          "& .MuiDataGrid-columnHeaders": {
           background: "black",
            borderBottom: "none",
             color: "#ffffff"
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[500],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.primary[800],
            color: "#ffffff"
           
          },
          "& .MuiButton-root": { color: "#ffffff" },
          "& .super-app-theme--header": {
            backgroundColor: colors.primary[200],
          },
          "& .MuiToolbar-root":{color :"#ffffff"},
          "&. MuiTablePagination-actions": {color: "white"},
          "& .MuiButtonBase-root": {color: colors.redAccent[500]}

        }}
      >
        <div style={{ width: '100%' }}>
        {isLoading ? (
         
         <Skeleton
           variant="rectangular"
           width="100%"
           height={500}
           animation="wave"
         />
       ) : (
        <RecordsTable
          columns={columns}
          rows={filteredData}
          getRowId={(row) => row.id}
          onRowDoubleClick={(params) => handleInfo(params.row.id, params.row.userId, params.row.posid)}
          emptyMessage="No transactions match your search."
        />
        )}
        </div>
        {/* This dialog opens the info about a selected client */}
              <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
          <DialogContent
            className="custom-dialog-size"
            sx={{ backgroundColor: colors.primary[500] }}
          >
            
              <div className="tabs-container">
                <Tabs
                  variant="scrollable"
                  scrollButtons="auto"
                  value = {tabValue}  
                >
                  <Tab
                    label="Info per Transaksion"
                    sx={{
                      color: "white",
                      backgroundColor: colors.primary[900],
                      margin: "2px",
                      borderRadius: "5px",
                  
                    }}
                  />
                  </Tabs>
              </div>

              <div
                    style={{
                      margin: "10px",
                      textAlign: "center",
                      display: isNonMobile ? undefined : "flex",
                      flexDirection: isNonMobile ? "row" : "column",
                    }}
                  >
                    <TextField
                      label="ID"
                      name="id"
                      value={transactionData.id ? transactionData.id : ""}
                      onChange={handleEdit}
                      style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "10px",
                      }}
                      variant="filled"
                      margin="dense"
                      disabled
                    />
                    <TextField
                      label="User ID"
                      name="userId"
                      value={transactionData.userId ? transactionData.userId : ""}
                      onChange={handleEdit}
                      style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "10px",
                      }}
                      variant="filled"
                      margin="dense"
                      disabled
                    />
                    <TextField
                    label="User Name"
                    value={username ? username : ""}
                    variant="filled"
                    margin="dense"
                    disabled
                    style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "10px",
                    }}
                    />
                    <TextField
                    label="Pos Name"
                    value={posName ? posName : ""}
                    variant="filled"
                    margin="dense"
                    disabled
                    style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "10px",
                    }}
                    />
                    <TextField
                      label="Transaction Amount"
                      name="transactionAmount"
                      value={transactionData.transactionAmount+" " ? transactionData.transactionAmount+ "€" : ""}
                      onChange={handleEdit}
                      disabled
                      style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "10px",
                      }}
                      variant="filled"
                      margin="dense"
                    />
                    <TextField
                      label="Bonus Points"
                      name="bonusPoints"
                      disabled
                      value={
                        transactionData.bonusPoints ? transactionData.bonusPoints : ""
                      }
                      onChange={handleEdit}
                      style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "10px",
                      }}
                      variant="filled"
                      margin="dense"
                    />
                 
                    <TextField
                      label="Discount Amount"
                      name="savedAmount"
                      value={transactionData.savedAmount ? transactionData.savedAmount+"€" : ""}
                      onChange={handleEdit}
                      variant="filled"
                      margin="dense"
                      disabled
                      style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "30px",
                      }}
                       
                    />
                    <TextField
                      label="Create Date"
                      name="createDate"
                      value={transactionData.createDate ? transactionData.createDate : ""}
                      onChange={handleEdit}
                      variant="filled"
                      margin="dense"
                      disabled
                      style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "10px",
                      }}
                      
                    />
                 
                  </div>
          <DialogActions className="custom-dialog-background">
                <Button
                  onClick={() => setDialogOpen(false)}
                  sx={{ backgroundColor: "white" }}
                >
                  Cancel
                </Button>
                
              </DialogActions>
              </DialogContent>
              </Dialog>
      </Box>
    </Box>
  );
};

export default Transactions;
